var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "field", class: { "select-search-disabled": _vm.disabled } },
    [
      _c("label", { staticClass: "label", attrs: { for: _vm.id } }, [
        _vm._v("\n    " + _vm._s(_vm.label) + "\n  ")
      ]),
      _c(
        "div",
        { staticClass: "control", class: { "is-loading": _vm.isLoading } },
        [
          _c(
            "VueSearchSelect",
            {
              attrs: {
                id: _vm.id,
                options: _vm.options,
                value: _vm.value,
                placeholder: _vm.placeholder,
                disabled: _vm.disabled,
                required: _vm.required,
                taggable: _vm.taggable,
                "select-on-tab": _vm.tab
              },
              on: {
                input: _vm.onChange,
                search: _vm.onSearch,
                "search:focus": function($event) {
                  return _vm.$emit("focus", _vm.$emit)
                },
                "search:blur": function($event) {
                  return _vm.$emit("blur", _vm.$emit)
                }
              }
            },
            [
              _c(
                "span",
                { attrs: { slot: "no-options" }, slot: "no-options" },
                [_vm._v("\n        " + _vm._s(_vm.emptyMessage) + "\n      ")]
              ),
              _vm._t("spinner", [
                _vm._v("\n        " + _vm._s(_vm.loadingMessage) + "\n      ")
              ])
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }